import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { PreVendaService } from '../../../services/pre-venda.service';
import { PreVenda } from '../../../models/pre-venda.model';

@Component({
  selector: 'app-list-pre-vendas',
  imports: [
    CommonModule,
    FormsModule,
    ConfirmDialogModule,
    ToastModule,
    TableModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    DatePickerModule,
    PaginatorModule,
    TooltipModule
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './list-pre-vendas.component.html'
})
export class ListPreVendasComponent implements OnInit {

  status = [
    { label: 'Todos', value: null},
    { label: 'Canceladas', value: true },
    { label: 'Ativas', value: false }
  ];

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  searchTerm: string = '';
  initialDate: Date = new Date();
  finalDate: Date = new Date();
  selectedStatus = this.status[0].value;
  preVendas: PreVenda[] = [];
  loading: boolean = false;
  totalRecords: number = 0;

  first: number = 0;
  rows: number = 5;
  currentPage: number = 1;
  
  constructor(
    private router: Router,
    private preVendaService: PreVendaService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
    // Inicializar datas com início e fim do dia
    const today = new Date();
    this.initialDate = this.getStartOfDay(today);
    this.finalDate = this.getEndOfDay(today);
    
    this.searchSubscription = this.searchSubject.pipe(
          debounceTime(300),
          distinctUntilChanged()
        ).subscribe((term: string) => {
          this.searchTerm = term;
          this.getData();
        });
  }

  private getStartOfDay(date: Date): Date {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  private getEndOfDay(date: Date): Date {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.loading = true;
    this.preVendaService.getAll(
      this.searchTerm,
      this.initialDate,
      this.finalDate,
      this.selectedStatus,
      this.currentPage
    ).subscribe({
      next: (response) => {
        this.preVendas = response.data ?? [];
        this.totalRecords = response.pagination?.totalRecords ?? 0;
        this.loading = false;
      },
      error: () => {
        this.preVendas = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    });
  }

  onSearchChange() {
    this.searchSubject.next(this.searchTerm);
  }

  onStatusChange(){
    // Garantir que as datas tenham hora zerada/início e fim do dia
    this.initialDate = this.getStartOfDay(this.initialDate);
    this.finalDate = this.getEndOfDay(this.finalDate);
    this.getData();
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  openPdvPreVendas(){
    const width = window.screen.width;
    const height = window.screen.height;
    window.open('/pre-vendas-pdv', 'PDV Pré-Vendas', `width=${width},height=${height},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no`);
  }

  view(preVenda: any){
    // TODO: Implementar visualização de pré-venda
    console.log('Visualizar pré-venda:', preVenda);
  }

  cancel(preVenda: any){
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar esta pré-venda?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        // TODO: Implementar cancelamento de pré-venda
        this.messageService.add({ severity: 'success', summary: 'Sucesso!', detail: 'Pré-venda cancelada com sucesso!', life: 3000 });
        this.getData();
      },
      reject: () => {
        console.log('Cancelamento cancelado');
      }
    });
  }

  export(){
    // TODO: Implementar exportação de pré-vendas
    console.log('Exportar pré-vendas');
  }
}
